import useConfigStore from '@/store/config.store';

function buildAuthentication({ userName, token }: { userName: string; token: string }): string {
    const base64Credentials = btoa(`${userName}:${token}`);
    return `Basic ${base64Credentials}`;
}

export default async function apiFetch(
    path: string,
    requestInit: RequestInit = {},
    additionalHeaders: [string, string][] = [],
): Promise<Response> {
    const configStore = useConfigStore();
    requestInit.headers = [
        ...additionalHeaders,
        ['Authorization', buildAuthentication({ userName: configStore.userName, token: configStore.token })],
    ];
    return fetch(`${import.meta.env.VITE_API_URL}${path}`, requestInit);
}
